import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";
import { type CreateMachineGroup, type DeleteMachineGroup, type MachineGroup } from "@/schemas";

const machineGroupApi = `${baseRoutes.machineGroup}/v1/MachineGroups`;

export async function getMachineGroups(): Promise<MachineGroup[]> {
	const response = await packNetAxios.get<MachineGroup[]>(machineGroupApi);
	// const validatedResponse = machineGroupsResponseSchema.safeParse(response.data); // TODO: Test parse
	// if (!validatedResponse.success) {
	// 	return [];
	// }
	// return validatedResponse.data;
	return response.data;
}

export async function createMachineGroup(data: CreateMachineGroup): Promise<void> {
	//const validatedRequest = createMachineGroupSchema.parse(data); // TODO: Test parse
	await packNetAxios.post(machineGroupApi, data);
}

export async function updateMachineGroup(data: MachineGroup): Promise<void> {
	//const validatedRequest = machineGroupSchema.parse(data); // TODO: Test parse
	await packNetAxios.put(`${machineGroupApi}/${data.id}`, data);
}

export async function deleteMachineGroup(id: string): Promise<DeleteMachineGroup> {
	const response = await packNetAxios.delete<DeleteMachineGroup>(`${machineGroupApi}/${id}`);
	return response.data;
}

export async function toggleMachineGroupProduction(machineGroupId: string): Promise<void> {
	await packNetAxios.get(`${machineGroupApi}/${machineGroupId}/toggle`);
}

export async function updateProductionEnabled(machineGroupId: string, enabled: boolean): Promise<void> {
	await packNetAxios.put(`${machineGroupApi}/${machineGroupId}/enableProduction`, { enabled });
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.machineGroup}/v1/version`);

	return response.data;
}
